<template>
  <div class="g-wrapper">
    <div class="g-main">
      <img src="../assets/agendaTitle.png" alt="" class="u-agendaTitle" />
    </div>
    <div class="g-tagList">
      <div
        :class="activeIndex == index ? 'm-tagItem active' : 'm-tagItem'"
        v-for="(item, index) in tab"
        :key="index"
        @click="changeAgenda(index)"
      >
        {{ item }}
        <span></span>
      </div>
    </div>
    <div class="g-agndaList">
      <!-- 2021第十届中国上市公司高峰论坛 -->
      <div class="m-agendaWrappr" v-show="activeIndex == 0 || activeIndex == 1">
        <div class="m-agndaBox u-agenda1">
          <div class="u-line"></div>
          <div class="u-agndaTime">
            <img src="../assets/icon2.png" alt="" class="u-iconTime" />
            <span class="u-time">2021/12/20</span>
            <span class="u-week">MON</span>
          </div>
          <div class="m-agendaMsg" v-for="(item, index) in forum1" :key="index">
            <div class="u-timeTag">{{ item.date }}</div>
            <div class="u-agndaTitle" v-if="index == 0">
              {{ item.title }} <br />{{ item.forumTheme }}
            </div>
            <div class="u-agandaItem" v-for="(a, b) in item.agenda" :key="b">
              <span class="u-doit"></span>
              <div class="u-timeArea">{{ a.time }}</div>
              <div class="u-seeion">
                <b>{{ a.text[0] }}</b>
                <div
                  v-for="(c, cIndex) in a.text"
                  :key="cIndex"
                  v-if="cIndex > 0"
                  class="u-agendaGuestName"
                >
                  <span
                    :class="
                      c.split('=')[0] == '对话嘉宾：' ||
                      c.split('=')[0] == '主持人：'
                        ? 'bloder'
                        : ''
                    "
                  >
                    <abbr v-for="(j, k) in c.split('=')[0]" :key="k">
                      {{ j }}
                    </abbr>
                  </span>
                  <span>
                    {{ c.split("=")[1] }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <img src="../assets/hr.png" alt="" class="u-hr" />
      </div>

      <!-- 12/21 -->
      <div class="m-agendaWrappr" v-show="activeIndex == 0 || activeIndex == 2">
        <div class="m-agndaBox u-agenda2">
          <div class="u-line"></div>
          <div class="u-agndaTime">
            <img src="../assets/icon2.png" alt="" class="u-iconTime" />
            <span class="u-time">2021/12/21</span>
            <span class="u-week">TUE</span>
          </div>
          <!-- 2021中国专精特新企业发展论坛 -->
          <div
            class="m-agendaMsg"
            v-for="(item, index) in forum2"
            :key="index"
            v-if="item.agenda.length > 0"
          >
            <div class="u-timeTag">{{ item.date }}</div>
            <div class="u-agndaTitle">
              {{ item.title }} <br />{{ item.forumTheme }}
            </div>
            <div class="u-agandaItem" v-for="(a, b) in item.agenda" :key="b">
              <span class="u-doit"></span>
              <div class="u-timeArea">{{ a.time }}</div>
              <div class="u-seeion">
                <b>{{ a.text[0] }}</b>
                                <div
                  v-for="(c, cIndex) in a.text"
                  :key="cIndex"
                  v-if="cIndex > 0"
                  class="u-agendaGuestName"
                >
                  <span
                    :class="
                      c.split('=')[0] == '对话嘉宾：' ||
                      c.split('=')[0] == '主持人：'
                        ? 'bloder'
                        : ''
                    "
                  >
                    <abbr v-for="(j, k) in c.split('=')[0]" :key="k">
                      {{ j }}
                    </abbr>
                  </span>
                  <span>
                    {{ c.split("=")[1] }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- 2021中国企业低碳发展论坛 -->
          <div
            class="m-agendaMsg"
            v-for="(item, index) in forum3"
            :key="index"
            v-if="item.agenda.length > 0"
          >
            <div class="u-timeTag">{{ item.date }}</div>
            <div class="u-agndaTitle">
              {{ item.title }} <br />{{ item.forumTheme }}
            </div>
            <div class="u-agandaItem" v-for="(a, b) in item.agenda" :key="b">
              <span class="u-doit"></span>
              <div class="u-timeArea">{{ a.time }}</div>
              <div class="u-seeion">
                <b>{{ a.text[0] }}</b>
                <div
                  v-for="(c, cIndex) in a.text"
                  :key="cIndex"
                  v-if="cIndex > 0"
                  class="u-agendaGuestName"
                >
                  <span
                    :class="
                      c.split('=')[0] == '对话嘉宾：' ||
                      c.split('=')[0] == '主持人：'
                        ? 'bloder'
                        : ''
                    "
                  >
                    <abbr v-for="(j, k) in c.split('=')[0]" :key="k">
                      {{ j }}
                    </abbr>
                  </span>
                  <span>
                    {{ c.split("=")[1] }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img src="../assets/hr.png" alt="" class="u-hr" />
      </div>

      <!-- 12/22 -->

      <div class="m-agendaWrappr" v-show="activeIndex == 0 || activeIndex == 3">
        <div class="m-agndaBox u-agenda3">
          <div class="u-line"></div>
          <div class="u-agndaTime">
            <img src="../assets/icon2.png" alt="" class="u-iconTime" />
            <span class="u-time">2021/12/22</span>
            <span class="u-week">WED</span>
          </div>
          <!-- 2021中国品质消费创新发展论坛 -->
          <div
            class="m-agendaMsg"
            v-for="(item, index) in forum4"
            :key="index"
            v-if="item.agenda.length > 0"
          >
            <div class="u-timeTag">{{ item.date }}</div>
            <div class="u-agndaTitle">
              {{ item.title }} <br />{{ item.forumTheme }}
            </div>
            <div class="u-agandaItem" v-for="(a, b) in item.agenda" :key="b">
              <span class="u-doit"></span>
              <div class="u-timeArea">{{ a.time }}</div>
              <div class="u-seeion">
                <b>{{ a.text[0] }}</b>
                <div
                  v-for="(c, cIndex) in a.text"
                  :key="cIndex"
                  v-if="cIndex > 0"
                  class="u-agendaGuestName"
                >
                  <span
                    :class="
                      c.split('=')[0] == '对话嘉宾：' ||
                      c.split('=')[0] == '主持人：'
                        ? 'bloder'
                        : ''
                    "
                  >
                    <abbr v-for="(j, k) in c.split('=')[0]" :key="k">
                      {{ j }}
                    </abbr>
                  </span>
                  <span>
                    {{ c.split("=")[1] }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- 2021中国医药健康资本论坛 -->
          <div
            class="m-agendaMsg"
            v-for="(item, index) in forum5"
            :key="index"
            v-if="item.agenda.length > 0"
          >
            <div class="u-timeTag">{{ item.date }}</div>
            <div class="u-agndaTitle">
              {{ item.title }} <br />{{ item.forumTheme }}
            </div>
            <div class="u-agandaItem" v-for="(a, b) in item.agenda" :key="b">
              <span class="u-doit"></span>
              <div class="u-timeArea">{{ a.time }}</div>
              <div class="u-seeion">
                <b>{{ a.text[0].replace("=",' ') }}</b>
                <div
                  v-for="(c, cIndex) in a.text"
                  :key="cIndex"
                  v-if="cIndex > 0"
                  class="u-agendaGuestName"
                >
                  <span
                    :class="
                      c.split('=')[0] == '对话嘉宾：' ||
                      c.split('=')[0] == '主持人：'
                        ? 'bloder'
                        : ''
                    "
                  >
                    <abbr v-for="(j, k) in c.split('=')[0]" :key="k">
                      {{ j }}
                    </abbr>
                  </span>
                  <span>
                    {{ c.split("=")[1] }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <img src="../assets/hr.png" alt="" class="u-hr" />
      </div>

      <!-- 12/23 -->
      <div class="m-agendaWrappr" v-show="activeIndex == 0 || activeIndex == 4">
        <div
          class="m-agndaBox u-agenda4"
          v-show="activeIndex == 0 || activeIndex == 4"
        >
          <div class="u-line"></div>
          <div class="u-agndaTime">
            <img src="../assets/icon2.png" alt="" class="u-iconTime" />
            <span class="u-time">2021/12/23</span>
            <span class="u-week">THU</span>
          </div>
          <!-- 2021 人工智能未来应用场景论坛 -->
          <div
            class="m-agendaMsg"
            v-for="(item, index) in forum6"
            :key="index"
            v-if="item.agenda.length > 0"
          >
            <div class="u-timeTag">{{ item.date }}</div>
            <div class="u-agndaTitle">
              {{ item.title }} <br />{{ item.forumTheme }}
            </div>
            <div class="u-agandaItem" v-for="(a, b) in item.agenda" :key="b">
              <span class="u-doit"></span>
              <div class="u-timeArea">{{ a.time }}</div>
              <div class="u-seeion">
                <b>{{ a.text[0] }}</b>
                                <div
                  v-for="(c, cIndex) in a.text"
                  :key="cIndex"
                  v-if="cIndex > 0"
                  class="u-agendaGuestName"
                >
                  <span
                    :class="
                      c.split('=')[0] == '对话嘉宾：' ||
                      c.split('=')[0] == '主持人：'
                        ? 'bloder'
                        : ''
                    "
                  >
                    <abbr v-for="(j, k) in c.split('=')[0]" :key="k">
                      {{ j }}
                    </abbr>
                  </span>
                  <span>
                    {{ c.split("=")[1] }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- 2021中国投资价值趋势论坛 -->
          <div
            class="m-agendaMsg"
            v-for="(item, index) in forum7"
            :key="index"
            v-if="item.agenda.length > 0"
          >
            <div class="u-timeTag">{{ item.date }}</div>
            <div class="u-agndaTitle">
              {{ item.title }} <br />{{ item.forumTheme }}
            </div>
            <div class="u-agandaItem" v-for="(a, b) in item.agenda" :key="b">
              <span class="u-doit"></span>
              <div class="u-timeArea">{{ a.time }}</div>
              <div class="u-seeion">
                <b>{{ a.text[0] }}</b>
                                <div
                  v-for="(c, cIndex) in a.text"
                  :key="cIndex"
                  v-if="cIndex > 0"
                  class="u-agendaGuestName"
                >
                  <span
                    :class="
                      c.split('=')[0] == '对话嘉宾：' ||
                      c.split('=')[0] == '主持人：'
                        ? 'bloder'
                        : ''
                    "
                  >
                    <abbr v-for="(j, k) in c.split('=')[0]" :key="k">
                      {{ j }}
                    </abbr>
                  </span>
                  <span>
                    {{ c.split("=")[1] }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img src="../assets/hr.png" alt="" class="u-hr" />
      </div>

      <!-- 12/24 -->
      <div
        class="m-agndaBox u-agenda5"
        v-show="activeIndex == 0 || activeIndex == 5"
      >
        <div class="u-line"></div>
        <div class="u-agndaTime">
          <img src="../assets/icon2.png" alt="" class="u-iconTime" />
          <span class="u-time">2021/12/24</span>
          <span class="u-week">FRI</span>
        </div>
        <!-- 2021第五届中国上市公司董秘峰会 -->
        <div
          class="m-agendaMsg"
          v-for="(item, index) in forum8"
          :key="index"
          v-if="item.agenda.length > 0"
        >
          <div class="u-timeTag">{{ item.date }}</div>
          <div class="u-agndaTitle">
            {{ item.title }} <br />{{ item.forumTheme }}
          </div>
          <div class="u-agandaItem" v-for="(a, b) in item.agenda" :key="b">
            <span class="u-doit"></span>
            <div class="u-timeArea">{{ a.time }}</div>
            <div class="u-seeion">
              <b>{{ a.text[0] }}</b>
                              <div
                  v-for="(c, cIndex) in a.text"
                  :key="cIndex"
                  v-if="cIndex > 0"
                  class="u-agendaGuestName"
                >
                  <span
                    :class="
                      c.split('=')[0] == '对话嘉宾：' ||
                      c.split('=')[0] == '主持人：'
                        ? 'bloder'
                        : ''
                    "
                  >
                    <abbr v-for="(j, k) in c.split('=')[0]" :key="k">
                      {{ j }}
                    </abbr>
                  </span>
                  <span>
                    {{ c.split("=")[1] }}
                  </span>
                </div>
            </div>
          </div>
        </div>

        <!-- 2021 中国上市公司品牌价值蓝皮书发布 -->
        <div
          class="m-agendaMsg"
          v-for="(item, index) in forum9"
          :key="index"
          v-if="item.agenda.length > 0"
        >
          <div class="u-timeTag">{{ item.date }}</div>
          <div class="u-agndaTitle">
            {{ item.title }} <br />{{ item.forumTheme }}
          </div>
          <div class="u-agandaItem" v-for="(a, b) in item.agenda" :key="b">
            <span class="u-doit"></span>
            <div class="u-timeArea">{{ a.time }}</div>
            <div class="u-seeion">
              <b>{{ a.text[0] }}</b>
                              <div
                  v-for="(c, cIndex) in a.text"
                  :key="cIndex"
                  v-if="cIndex > 0"
                  class="u-agendaGuestName"
                >
                  <span
                    :class="
                      c.split('=')[0] == '对话嘉宾：' ||
                      c.split('=')[0] == '主持人：'
                        ? 'bloder'
                        : ''
                    "
                  >
                    <abbr v-for="(j, k) in c.split('=')[0]" :key="k">
                      {{ j }}
                    </abbr>
                  </span>
                  <span>
                    {{ c.split("=")[1] }}
                  </span>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: ["全部", "12/20", "12/21", "12/22", "12/23", "12/24"],
      activeIndex: 0,
      forum1: [],
      forum2: [],
      forum3: [],
      forum4: [],
      forum5: [],
      forum6: [],
      forum7: [],
      forum8: [],
      forum9: [],
    };
  },
  methods: {
    getAgenda(forumName, forum, forumTheme) {
      let that = this;
      $.ajax({
        url:
          "http://www.nbd.com.cn/zhuanti/cfg_stores/get_by_activity_name?activity_name=" +
          forumName +
          "&cfg_type=array&t=" +
          Date.parse(new Date()),
        methods: "get",
        success: function (data) {
          console.log(data);
          let newAgendaList = [
            {
              date: "上午",
              agenda: [],
              title: forumName,
              forumTheme: forumTheme,
            },
            {
              date: "下午",
              agenda: [],
              title: forumName,
              forumTheme: forumTheme,
            },
          ];

          data.cfg.map((item) => {
            let agendaItem = {};
            agendaItem.time = item["时间"];
            if (item["内容以&符号解析成换行"]) {
              agendaItem.text = item["内容以&符号解析成换行"].split("&");
            } else {
              agendaItem.text = [];
            }

            if (item["上/下午"] == "上午") {
              newAgendaList[0].agenda.push(agendaItem);
            } else {
              newAgendaList[1].agenda.push(agendaItem);
            }
          });
          console.log(newAgendaList);
          that[forum] = newAgendaList;
        },
      });
    },

    changeAgenda(index) {
      this.activeIndex = index;
    },
  },
  created() {
    this.getAgenda(
      "2021第十届中国上市公司高峰论坛",
      "forum1",
      "科技创新 绿色发展"
    );
    this.getAgenda(
      "2021中国专精特新企业发展论坛",
      "forum2",
      "寻找隐形冠军 拥抱时代机遇"
    );
    this.getAgenda(
      "2021中国企业低碳发展论坛",
      "forum3",
      "碳中和新局  现实与路径"
    );
    this.getAgenda("2021中国品质消费创新发展论坛", "forum4", "新韧劲 新活力");
    this.getAgenda(
      "2021中国医药健康资本论坛",
      "forum5",
      "启智未来：后疫情时代蝶变"
    );

    this.getAgenda(
      "2021人工智能未来应用场景论坛",
      "forum6",
      "AI是最强大脑吗？"
    );
    this.getAgenda("2021中国投资价值趋势论坛", "forum7", "成长2022");
    this.getAgenda(
      "2021第五届中国上市公司董秘峰会",
      "forum8",
      "ESG：全新机遇 共同责任"
    );
    this.getAgenda(
      "2021中国上市公司品牌价值蓝皮书",
      "forum9",
      "暨2021中国资本市场荣誉盛典"
    );
  },
};
</script>

<style lang='scss' scoped>
.u-agendaTitle {
  width: 501px;
  height: 118px;
  display: block;
  margin: 30px auto;
}
.g-tagList {
  background: url("../assets/tabBg.png") no-repeat;
  background-size: 100% 100%;
  height: 70px;
  padding: 0 40px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  .m-tagItem {
    font-size: 36px;
    color: #4383b8;
    height: 70px;
    line-height: 70px;
    position: relative;
    &.active {
      span {
        display: inline;
      }
    }
    span {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      height: 4px;
      border-radius: 8px;
      background: #ff813d;
      display: none;
    }
  }
}
.g-agndaList {
  width: 730px;
  margin: 0 auto;
  background: #fff;
  padding-top: 46px;
  margin-top: 2px;
}
.u-iconTime {
  width: 29px;
  height: 29px;
  margin-right: 15px;
}
.u-agndaTime {
  height: 46px;
  width: 699px;
  color: #fff;
  display: flex;
  justify-content: flex-start;
  padding-left: 30px;
  box-sizing: border-box;
  align-items: center;
  z-index: 999;
  position: relative;
  .u-time {
    font-size: 32px;
    margin-left: 15px;
  }
  .u-week {
    font-size: 20px;
    margin-left: 40px;
  }
  //   &.u-agenda1bg {
  //     background: url("../assets/agenda1Bg.png") no-repeat;
  //     background-size: 100% 100%;
  //   }
}
.m-agndaBox {
  // margin-top: 46px;
  position: relative;
  overflow: hidden;
  &.u-agenda1 {
    .u-agndaTime {
      background: url("../assets/agenda1Bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .u-timeTag {
      background: #034782;
    }
    .u-agndaTitle {
      color: #034782;
    }
    .u-doit {
      background: #034782;
    }
    .u-timeArea {
      color: #034782;
    }
  }
  &.u-agenda2 {
    .u-agndaTime {
      background: url("../assets/agenda2Bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .u-timeTag {
      background: #a68463;
    }
    .u-agndaTitle {
      color: #a68463;
    }
    .u-doit {
      background: #a68463;
    }
    .u-timeArea {
      color: #a68463;
    }
    .m-agendaMsg:last-child {
      .u-timeTag {
        background: #5f93d3;
      }
      .u-agndaTitle {
        color: #5f93d3;
      }
      .u-doit {
        background: #5f93d3;
      }
      .u-timeArea {
        color: #5f93d3;
      }
    }
  }

  &.u-agenda3 {
    .u-agndaTime {
      background: url("../assets/agenda3Bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .u-timeTag {
      background: #5d40ac;
    }
    .u-agndaTitle {
      color: #5d40ac;
    }
    .u-doit {
      background: #5d40ac;
    }
    .u-timeArea {
      color: #5d40ac;
    }
    .m-agendaMsg:last-child {
      .u-timeTag {
        background: #0a9995;
      }
      .u-agndaTitle {
        color: #0a9995;
      }
      .u-doit {
        background: #0a9995;
      }
      .u-timeArea {
        color: #0a9995;
      }
    }
  }

  &.u-agenda4 {
    .u-agndaTime {
      background: url("../assets/agenda4Bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .u-timeTag {
      background: #283d9e;
    }
    .u-agndaTitle {
      color: #283d9e;
    }
    .u-doit {
      background: #283d9e;
    }
    .u-timeArea {
      color: #283d9e;
    }
    .m-agendaMsg:last-child {
      .u-timeTag {
        background: #c8070a;
      }
      .u-agndaTitle {
        color: #c8070a;
      }
      .u-doit {
        background: #c8070a;
      }
      .u-timeArea {
        color: #c8070a;
      }
    }
  }

  &.u-agenda5 {
    .u-agndaTime {
      background: url("../assets/agenda5Bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .u-timeTag {
      background: #f48d27;
    }
    .u-agndaTitle {
      color: #f48d27;
    }
    .u-doit {
      background: #f48d27;
    }
    .u-timeArea {
      color: #f48d27;
    }
    .m-agendaMsg:last-child {
      .u-timeTag {
        background: #a2400f;
      }
      .u-agndaTitle {
        color: #a2400f;
      }
      .u-doit {
        background: #a2400f;
      }
      .u-timeArea {
        color: #a2400f;
      }
    }
  }

  .u-line {
    width: 1px;
    height: 800000000px;
    background: #dbdbde;
    position: absolute;
    top: 0;
    left: 36px;
    z-index: 200;
  }
}
.m-agendaMsg {
  padding: 0 36px;
  margin-top: 60px;
}
.u-timeTag {
  width: 100px;
  height: 40px;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  color: #fff;
  font-size: 26px;
  line-height: 40px;
  text-align: center;
}
.u-agndaTitle {
  font-size: 36px;
  text-align: justify;
  //   line-height: 1.2;
  width: 668px;
  height: 100px;
  padding-left: 45px;
  box-sizing: border-box;
  background: #eeeeee;
  border-top-right-radius: 64px;
  border-bottom-right-radius: 64px;
  margin-top: 22px;
  align-items: center;
  display: flex;
}
.u-agandaItem {
  display: flex;
  flex-direction: row;
  align-items: top;
  margin-top: 30px;
}
.u-doit {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-top: 22px;
  margin-left: -7px;
  flex-shrink: 0;
  z-index: 999;
}
.u-timeArea {
  width: 225px;
  height: 45px;
  border-radius: 25px;
  background: #eee;
  font-size: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  font-weight: bolder;
  flex-shrink: 0;
}
.u-seeion {
  font-size: 26px;
  color: #313131;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  align-self: center;
}

.u-agendaGuestName {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow: hidden;
  span {
    &:first-child {
      min-width: 100px;
      text-align: justify;
      margin-right: 15px;
      flex-shrink: 0;
      text-align-last: justify;
      white-space: nowrap;
      display: flex;
      justify-content: space-between;
      .i {
        width: 100%;
        display: block;
      }
      &.bloder {
        font-weight: bolder;
        margin: 10px 0;
      }
    }
    &:last-child {
      width: 290px;
    }
  }
}
</style>